export default "__VITE_ASSET__9XR6afVJ__"